import { ITimeSource } from '@fe/core';
import { BaseTimeSource } from './base-time-source';

export class LiveTimeSource extends BaseTimeSource implements ITimeSource {
    private timeNow = Math.floor(Date.now() / 1000);
    private timeout: number | undefined;

    constructor() {
        super();
        this.loop();
    }

    private loop = () => {
        const timeMs = Date.now();
        this.timeNow = Math.floor(timeMs / 1000);
        this.timeout = self.setTimeout(this.loop, 1000 - (timeMs % 1000));
        this.fire(this.timeNow);
    };

    get currentTime(): number {
        return this.timeNow;
    }

    get currentTimeMs(): number {
        return Date.now();
    }

    finalize() {
        if (this.timeout) {
            self.clearTimeout(this.timeout);
            this.timeout = undefined;
        }
    }
}
